import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { computed } from 'zustand-middleware-computed-state';

const useUserStore = create(
  computed(
    persist(
      (set) => ({
        user: null,
        setUser: (user) => {
          set({ user });
        }
      }),
      {
        name: 'userStore',
        storage: createJSONStorage(() => localStorage)
      }
    ),
    (state) => {
      return {
        user: state.user
      };
    }
  )
);

export default useUserStore;
